import React from 'react';
import { components } from 'react-select';
import { Text } from '@atlaskit/primitives';
/**
 * __No options message__
 */
export const NoOptionsMessage = props => {
  return /*#__PURE__*/React.createElement(components.NoOptionsMessage, props, /*#__PURE__*/React.createElement("span", {
    id: "no-options",
    role: "alert"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle"
  }, props.children || `No options`)));
};